/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 契約値レイアウト情報
 */
export interface Szma301aResponseConvalLayoutMst { 
    /**
     * 契約種別コード：英数字
     */
    ctrClsfyCode?: string;
    /**
     * 商品コード：英数字
     */
    goodsCode?: string;
    /**
     * 固有エリア識別区分：半角
     */
    nativeAreaDiv?: string;
    /**
     * 項目ID：半角
     */
    itemId?: string;
    /**
     * 適用開始年月日：日付(yyyyMMdd)
     */
    efctStartDate?: string;
    /**
     * 適用終了年月日：日付(yyyyMMdd)
     */
    efctEndDate?: string;
    /**
     * 項目名称：全角
     */
    itemAname?: string;
    /**
     * 項目位置
     */
    itemPosit?: number;
    /**
     * 項目サイズ
     */
    itemSize?: number;
    /**
     * 項目タイプ：半角
     */
    itemType?: string;
    /**
     * 取得元使用量区分：英数字
     */
    shtkmtEleccspDiv?: string;
    /**
     * 取得元項目位置
     */
    shtkmtItemPosit?: number;
    /**
     * 社員番号：英数字
     */
    staffNo?: string;
    /**
     * 操作コード：英数字
     */
    oprCode?: string;
    /**
     * 登録日時：日付(yyyyMMddHHmmss)
     */
    registHms?: string;
    /**
     * 更新日時：日付(yyyyMMddHHmmss)
     */
    updateHms?: string;
    /**
     * 項目値：半角
     */
    itemValue?: string;
}

